import { baseApi } from "./baseApi";

export const reportApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSubscriptionReport: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/v2/report/subscription",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Report"],
    }),
  }),
});

export const { useGetSubscriptionReportMutation } = reportApi;
